export enum OrderTradeTypeCodeEnum {
  /** 通常 */ NORMAL = '01',
  /** 摘要 */ REMARK = '02',
  /** 返品(良品) */ RETURN_NOT_DAMAGED = '03',
  /** 返品(不良品) */ RETURN_DAMAGED = '04',
  /** 送料 */ POSTAGE = '05',
  /** 手数料 */ CHARGE = '06',
  /** 値引 */ DISCOUNT = '07',
  /** 交換 */ CHANGED = '08',
}

export const NormalOrderTradeTypeCode = [
  { label: '通常', value: OrderTradeTypeCodeEnum.NORMAL },
  { label: '摘要', value: OrderTradeTypeCodeEnum.REMARK },
  { label: '送料', value: OrderTradeTypeCodeEnum.POSTAGE },
  { label: '手数料', value: OrderTradeTypeCodeEnum.CHARGE },
  { label: '値引', value: OrderTradeTypeCodeEnum.DISCOUNT },
];

export const ReturnOrderTradeTypeCode = [
  { label: '返品(良品)', value: OrderTradeTypeCodeEnum.RETURN_NOT_DAMAGED },
  { label: '返品(不良品)', value: OrderTradeTypeCodeEnum.RETURN_DAMAGED },
  { label: '摘要', value: OrderTradeTypeCodeEnum.REMARK },
  { label: '送料', value: OrderTradeTypeCodeEnum.POSTAGE },
  { label: '手数料', value: OrderTradeTypeCodeEnum.CHARGE },
  { label: '値引', value: OrderTradeTypeCodeEnum.DISCOUNT },
];

export const ChangedOrderTradeTypeCode = [
  { label: '交換', value: OrderTradeTypeCodeEnum.CHANGED },
  { label: '摘要', value: OrderTradeTypeCodeEnum.REMARK },
];

export const OrderTradeTypeCode = [
  { label: '通常', value: OrderTradeTypeCodeEnum.NORMAL },
  { label: '摘要', value: OrderTradeTypeCodeEnum.REMARK },
  { label: '返品(良品)', value: OrderTradeTypeCodeEnum.RETURN_NOT_DAMAGED },
  { label: '返品(不良品)', value: OrderTradeTypeCodeEnum.RETURN_DAMAGED },
  { label: '送料', value: OrderTradeTypeCodeEnum.POSTAGE },
  { label: '手数料', value: OrderTradeTypeCodeEnum.CHARGE },
  { label: '値引', value: OrderTradeTypeCodeEnum.DISCOUNT },
  { label: '交換', value: OrderTradeTypeCodeEnum.CHANGED },
];
